import { styled } from 'styled-components';

const WraperOptions = styled.div`
  display: flex;
  gap: 12px;
  flex-direction: column;
`;

const OptionItem = styled.div`
  align-items: center;
  display: flex;
  gap: 12px;
  padding: 8px 12px;
  border-radius: 5px;
  background: rgba(61, 60, 65, 0.5);
  cursor: pointer;
  flex-wrap: wrap;

  ${({ $isActive }) =>
    $isActive &&
    `
    border: 2px solid #FF9F0A;
    background: rgba(255, 159, 10, 0.10);
    `}
`;

const InfoEl = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
`;

export { WraperOptions, OptionItem, InfoEl };
